/**
 * the supported Geometry Types
 */
export enum ApGeometryType {
  POINT,
  LINE,
  POLYGON
}
